<div class="tr-page">

  <!-- ── Page header ──────────────────────────────────────────── -->
  <div class="tr-header">
    <div class="tr-header__left">
      <div class="tr-header__icon">
        <mat-icon>schedule</mat-icon>
      </div>
      <div>
        <h1 class="tr-header__title">Turnos</h1>
        <p class="tr-header__sub">Configura los horarios y turnos del equipo</p>
      </div>
    </div>
    <div class="tr-header__actions">
      <button mat-flat-button class="tr-btn-primary" (click)="create()">
        <mat-icon>add</mat-icon> Nuevo turno
      </button>
      <app-help key="Personal3"></app-help>
    </div>
  </div>

  <!-- ── Loading ──────────────────────────────────────────────── -->
  <div class="tr-loading" *ngIf="(TurnosService.loading$ | async)">
    <div class="tr-loading__icon-wrap"><mat-icon>schedule</mat-icon></div>
    <div class="tr-loading__dots"><span></span><span></span><span></span></div>
    <p class="tr-loading__text">Cargando turnos…</p>
  </div>

  <!-- ── Contenido ────────────────────────────────────────────── -->
  <ng-container *ngIf="!(TurnosService.loading$ | async)">

    <!-- Empty state -->
    <div class="tr-empty" *ngIf="(listaTurnos$ | async) === null || (listaTurnos$ | async)?.length === 0">
      <div class="tr-empty__art">
        <mat-icon>event_busy</mat-icon>
      </div>
      <h3 class="tr-empty__title">Sin turnos configurados</h3>
      <p class="tr-empty__sub">Crea el primer turno para empezar a asignar horarios al equipo.</p>
      <button mat-flat-button class="tr-btn-primary tr-btn-primary--lg" (click)="create()">
        <mat-icon>add</mat-icon> Crear primer turno
      </button>
    </div>

    <!-- Tabla de turnos -->
    <div class="tr-card" *ngIf="(listaTurnos$ | async)?.length > 0">

      <table mat-table [dataSource]="listaTurnos$ | async" matSort class="tr-table">

        <!-- Empleado -->
        <ng-container matColumnDef="employees_Id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Empleado</th>
          <td mat-cell *matCellDef="let row">
            <div class="tr-cell-employee">
              <div class="tr-avatar">{{ nombreEmpleado(row.employees_Id) | slice:0:1 }}</div>
              <span>{{ nombreEmpleado(row.employees_Id) }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Nombre del turno -->
        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre del turno</th>
          <td mat-cell *matCellDef="let row">
            <span class="tr-shift-name">{{ row.nombre }}</span>
          </td>
        </ng-container>

        <!-- Tipo -->
        <ng-container matColumnDef="tipo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
          <td mat-cell *matCellDef="let row">
            <span class="tr-badge">{{ nombreTipoTurno(row.tipo) }}</span>
          </td>
        </ng-container>

        <!-- Inicio -->
        <ng-container matColumnDef="cadenaInicio">
          <th mat-header-cell *matHeaderCellDef>Inicio</th>
          <td mat-cell *matCellDef="let row">
            <span class="tr-date">{{ row.cadenaInicio || '—' }}</span>
          </td>
        </ng-container>

        <!-- Fin -->
        <ng-container matColumnDef="cadenaFin">
          <th mat-header-cell *matHeaderCellDef>Fin</th>
          <td mat-cell *matCellDef="let row">
            <span class="tr-date">{{ row.cadenaFin || '—' }}</span>
          </td>
        </ng-container>

        <!-- Acciones -->
        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef class="tr-col-actions"></th>
          <td mat-cell *matCellDef="let row" class="tr-col-actions">
            <button mat-icon-button [matMenuTriggerFor]="rowMenu" (click)="setRow(row)" class="tr-menu-trigger"
                    matTooltip="Acciones">
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="tr-row"></tr>
      </table>

    </div>

  </ng-container>

</div>

<!-- ── Menú de acciones ──────────────────────────────────────── -->
<mat-menu #rowMenu="matMenu">
  <button mat-menu-item (click)="editar()">
    <mat-icon>edit</mat-icon>
    <span>Editar</span>
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item class="tr-action-danger" (click)="eliminar(row?.id)">
    <mat-icon>delete</mat-icon>
    <span>Borrar</span>
  </button>
</mat-menu>
